(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._active = false;
      this._skipped = false;

      this._belowStake = ["winBelow"];

      this._smallWins = ["winLow0", "winLow1", "winLow2"];

      this._medWins = ["winMed0", "winMed0"];

      this._highWins = ["winHigh0", "winHigh1", "winHigh2"];
    }

    initialise(json) {
      this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);

      this._symbolAnimator = json.symbolAnimator
        ? resourceManager.get(json.symbolAnimator)
        : undefined;
      this._winlineAnimator = json.winlineAnimator
        ? resourceManager.getSharedPlugin(json.winlineAnimator)
        : undefined;
    }

    startAnimations(
      winData,
      celebrationThreshold,
      slotMachine,
      completeCallback
    ) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      let currentSequence = 0;
      let playNextSequence = function (i) {
        if (canCelebrate) {
          // hunters moon hack, only play symbol win soun don the all batch
          let bestSymbolWin = -1;
          if (currentSequence === 0) {
            for (let j = 0; j < sequenceData[i].length; ++j) {
              if (sequenceData[i][j].winId > bestSymbolWin) {
                bestSymbolWin = sequenceData[i][j].winId;
              }
            }
          } else {
            bestSymbolWin = 0;
          }

          // Play the win sound here based on win amount
          const winnings = winData.totalLineWinnings;
          const stake = gameController.getCurrentModeStake();
          if (winnings <= stake) {
            self.playRandomSounds(self._belowStake);
          } else if (winnings < stake * 2) {
            self.playRandomSounds(self._smallWins);
          } else if (winnings < stake * 5) {
            self.playRandomSounds(self._medWins);
          } else {
            self.playRandomSounds(self._highWins);
          }
        }

        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        self._winlineAnimator.playAnimations(
          winlines,
          sequenceData[i],
          slotMachine,
          function () {}
        );

        if (self._symbolAnimator) {
          self._symbolAnimator.animateSymbols(
            sequenceData[i],
            slotMachine,
            canCelebrate,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            function () {}
          );
        }
      };
      playNextSequence(currentSequence);
    }

    playRandomSounds(list) {
      const soundIndex = Math.floor(Math.random() * list.length);
      soundManager.play(list[soundIndex]);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController(
    "WinControllerAllAtOnce",
    createWinController
  );
})();
